goog.provide("shadow.js.shim.module$$tiptap$extension_paragraph");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_paragraph");
shadow.js.shim.module$$tiptap$extension_paragraph = shadow.js.nativeProvides["@tiptap/extension-paragraph"] = shadow$bridge("@tiptap/extension-paragraph");
module$shadow_js_shim_module$$tiptap$extension_paragraph.default = shadow.js.shim.module$$tiptap$extension_paragraph;
